export default {
    init() {
    },
    finalize() {
    }
};

// Sticky header behavior:
// - After the page is scrolled down at least 200px the header will slide up when
//   the user scrolls down and slide back into view when the user scrolls up.
// - It uses requestAnimationFrame to throttle work and toggles `.is-hidden` and
//   `.is-sticky` classes on the `header` element. Add CSS for those classes
//   (example below) to control the animation/position:
//
// header { transition: transform 0.25s ease, top 0.25s ease; }
// header.is-sticky { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; }
// header.is-hidden { transform: translateY(-100%); }

; (function () {
    const HEADER_SELECTOR = 'header';
    const SHOW_AFTER_SCROLL = 300; // px
    let lastScrollY = window.scrollY || 0;
    let ticking = false;
    let header = null;

    function onScroll() {
        lastScrollY = window.scrollY || 0;
        requestTick();
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(update);
        }
        ticking = true;
    }

    function update() {
        ticking = false;
        if (!header) return;

        const currentY = lastScrollY;
        const delta = currentY - (update._lastY || currentY);
        update._lastY = currentY;

        // Toggle `small` as soon as the user scrolls away from the top
        if (currentY > 0) {
            header.classList.add('small');
        } else {
            header.classList.remove('small');
        }

        // If the user hasn't scrolled past the threshold yet, keep header visible
        if (currentY <= SHOW_AFTER_SCROLL) {
            header.classList.remove('is-hidden');
            return;
        }

        // Now the user is past the threshold: hide on scroll down, show on scroll up
        if (delta > 0) {
            header.classList.add('is-hidden');
        } else if (delta < 0) {
            header.classList.remove('is-hidden');
        }
    }

    function initStickyHeader() {
        header = document.querySelector(HEADER_SELECTOR);
        if (!header) return;

        // Make header sticky immediately
        header.classList.add('is-sticky');

        // Seed last known Y so the first delta is stable
        update._lastY = window.scrollY || 0;

        window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStickyHeader);
    } else {
        initStickyHeader();
    }
})();

// Add 'menu-open' class to body on top-level menu item hover
document.addEventListener('DOMContentLoaded', function () {
    var topLevelMenuItems = document.querySelectorAll('.nav-main > li.nav-item.large, .nav-main > li.nav-item.right');
    topLevelMenuItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
            document.body.classList.add('menu-open');
        });
        item.addEventListener('mouseleave', function () {
            document.body.classList.remove('menu-open');
        });
    });
});